import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';

import { useCreateLibraryMutation } from '@classCreation/services/libraryService';
import Field from 'components/Field';
import Form from 'components/Form';
import Input from 'components/Input';

export default function CreateLibraryForm({
  className,
  inputClassName,
  fieldClassName,
  buttonClassName,
  onSuccess,
  onFailure,
}) {
  const [libraryName, setLibraryName] = useState('');
  const [createLibrary, { data, isSuccess, error, isLoading: isCreating }] =
    useCreateLibraryMutation();

  const handleChange = useCallback((event) => {
    setLibraryName(event.target.value);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Library is successfully created!');
      onSuccess(data.data);
    }
    if (error) {
      if (onFailure) {
        onFailure(error.data);
      }
      cogoToast.error(error.data?.message || 'Failed to create library!');
    }
  }, [data, error, isSuccess, onFailure, onSuccess]);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      createLibrary({ libraryName });
    },
    [createLibrary, libraryName]
  );

  return (
    <Form
      className={className}
      onSubmit={handleSubmit}
      serverErrors={error?.data?.errors}
    >
      <Field
        name="title"
        label="Library Details"
        className={fieldClassName}
        serverErrors={error?.data?.errors}
      >
        <Input
          required
          type="text"
          placeholder="Enter Library Name"
          className={classNames({
            [inputClassName]: inputClassName,
          })}
          value={libraryName}
          onChange={handleChange}
          name="libraryName"
        />
      </Field>
      <Tappable
        type="submit"
        disabled={isCreating}
        component="button"
        className={classNames('btn btn-primary btn-long', {
          [buttonClassName]: buttonClassName,
        })}
      >
        Create Library
      </Tappable>
    </Form>
  );
}

CreateLibraryForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  fieldClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
};
